import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const CheckoutSuccess = () => {
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get("order");

    return (
        <div className="min-h-[80vh] bg-[radial-gradient(circle_at_top,_rgba(227,38,54,0.16),_transparent_35%),linear-gradient(180deg,#fff8f2_0%,#ffffff_52%,#f4f1ea_100%)] px-4 py-12 md:px-8 md:py-20">
            <div className="mx-auto max-w-3xl border-4 border-ink bg-white p-8 text-center brutal-shadow-red md:p-14">
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border-2 border-ink bg-[#f7f4ee]">
                    <CheckCircle2 className="h-8 w-8 text-hazard" />
                </div>

                <p className="mt-6 font-mono-ui text-xs uppercase tracking-[0.3em] text-hazard">
                    Order Update
                </p>

                <h1 className="mt-3 font-heading text-5xl uppercase leading-[0.9] text-ink md:text-7xl">
                    Order Request Saved
                </h1>

                <p className="mx-auto mt-6 max-w-2xl text-lg text-foreground/80 md:text-2xl">
                    We&apos;ve successfully completed your purchase.
                </p>
                {orderId ? (
                    <p className="mt-4 font-mono-ui text-xs uppercase tracking-[0.24em] text-muted-foreground">
                        Reference: {orderId}
                    </p>
                ) : null}

                <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
                    <Link
                        to="/shop"
                        className="inline-flex items-center justify-center border-2 border-ink bg-hazard px-6 py-4 font-mono-ui text-xs uppercase tracking-[0.24em] text-white hover:bg-ink"
                    >
                        Continue Shopping
                    </Link>
                    <Link
                        to="/contact"
                        className="inline-flex items-center justify-center border-2 border-ink bg-white px-6 py-4 font-mono-ui text-xs uppercase tracking-[0.24em] hover:bg-[#f6f0e8]"
                    >
                        Contact Support
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CheckoutSuccess;
